import React, { useState } from "react";

// Studio + quick sheet: optional name, then Start with a beat / Start blank.
export const StudioCreateSheet = ({ open, creating, onClose, onCreate }) => {
  const [title, setTitle] = useState("");
  if (!open) return null;
  return (
    <>
      <div className="fixed inset-0 z-[60] bg-black/60" onClick={onClose} data-testid="studio-create-scrim" />
      <div
        className="fixed left-0 right-0 bottom-0 z-[61] mx-auto max-w-lg rounded-t-3xl bg-[#100c1c] border-t border-x border-amber-400/20 p-5"
        style={{ paddingBottom: "max(1.25rem, env(safe-area-inset-bottom))" }}
        role="dialog"
        aria-label="New studio session"
        data-testid="studio-create-sheet"
      >
        <div className="mx-auto w-10 h-1 rounded-full bg-white/20 mb-4" />
        <div className="flex items-center justify-between mb-3">
          <h3 className="text-lg font-black">New session</h3>
          <button type="button" onClick={onClose} className="text-xs text-gray-400 hover:text-white" data-testid="studio-create-close">
            Cancel
          </button>
        </div>
        <input
          value={title}
          onChange={(e) => setTitle(e.target.value.slice(0, 80))}
          placeholder="Session name (optional)"
          className="w-full h-11 px-3 rounded-xl bg-black/40 border border-white/10 text-white placeholder:text-gray-500 focus:outline-none focus:border-fuchsia-400/60"
          data-testid="studio-new-title"
        />
        <div className="grid grid-cols-2 gap-3 mt-4">
          <button
            type="button"
            disabled={creating}
            onClick={() => onCreate({ title, withBeat: true })}
            className="p-4 rounded-2xl text-left bg-gradient-to-br from-fuchsia-600/30 to-purple-900/40 border border-fuchsia-400/40 disabled:opacity-50"
            data-testid="studio-create-with-beat"
          >
            <p className="text-sm font-black">Start with a beat</p>
            <p className="text-[11px] text-gray-300 mt-1">Pick a beat, then record vocals</p>
          </button>
          <button
            type="button"
            disabled={creating}
            onClick={() => onCreate({ title, withBeat: false })}
            className="p-4 rounded-2xl text-left bg-white/[0.04] border border-white/15 disabled:opacity-50"
            data-testid="studio-create-blank"
          >
            <p className="text-sm font-black">Start blank</p>
            <p className="text-[11px] text-gray-400 mt-1">Name it now, add a beat later</p>
          </button>
        </div>
        {creating && <p className="text-xs text-gray-400 mt-3" data-testid="studio-creating">Starting…</p>}
      </div>
    </>
  );
};

export default StudioCreateSheet;
